import { Link } from '@solidjs/meta';

export function NotoSerif()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,100..900;1,100..900&display=swap' rel='stylesheet' />
	</>);
}

NotoSerif.fontFamily = '"Noto Serif", serif';
